import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const GitHubUserInfo = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [reposData, setReposData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Number of items per page
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const accessToken = urlParams.get("access_token");

    if (accessToken) {
      fetchUserInfo(accessToken);
      fetchUserRepos(accessToken);
    } else {
      console.error("Access token not found.");
    }
  }, [location]);

  const fetchUserInfo = async (token) => {
    try {
      const response = await fetch("https://api.github.com/user", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setUserInfo(data);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  const fetchUserRepos = async (token) => {
    try {
      const response = await fetch("https://api.github.com/user/repos", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setReposData(data);
    } catch (error) {
      console.error("Error fetching user repos:", error);
    }
  };

  // Calculate the current page's items
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = reposData.slice(indexOfFirstItem, indexOfLastItem);

  // Check if we're on the first or last page to disable buttons accordingly
  const isFirstPage = currentPage === 1;
  const isLastPage = indexOfLastItem >= (reposData?.length || 0);

  return (
    <div>
      <div className="center">
        <h1>GitHub Repository Analyzer</h1>
        <h2>Logged in as: {userInfo?.login || "Loading..."}</h2>
      </div>

      {/* Repository List */}
      <div>
        {currentItems.map((repo) => (
          <div key={repo.id}>
            <h3>{repo.name}</h3>
            <p>{repo.description}</p>
          </div>
        ))}
      </div>

      {/* Pagination Buttons */}
      <div>
        <button onClick={() => setCurrentPage(currentPage - 1)} disabled={isFirstPage}>
          Previous
        </button>
        <button onClick={() => setCurrentPage(currentPage + 1)} disabled={isLastPage}>
          Next
        </button>
      </div>
    </div>
  );
};

export default GitHubUserInfo;